import { render, staticRenderFns } from "./AsyncProvider.vue?vue&type=template&id=1f044d3e&scoped=true"
import script from "./AsyncProvider.vue?vue&type=script&lang=ts"
export * from "./AsyncProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f044d3e",
  null
  
)

export default component.exports